import React from 'react';
import { classNames } from 'primereact/utils';
import { Button, ButtonProps, ButtonVariant, ButtonVariantSize } from '../Button';
import './ButtonGroup.scss';

export type ButtonGroupProps = {
	buttons: Array<
		{
			key: string;
		} & Omit<ButtonProps, 'variantSize'>
	>;
	variant?: ButtonVariant;
	variantSize?: ButtonVariantSize;
	disabled?: boolean;
	iconOnly?: boolean;
	className?: string;
};

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
	buttons,
	variant,
	variantSize,
	disabled,
	iconOnly = false,
	className,
}) => {
	return (
		<div className={classNames('button-group', className)}>
			{buttons.map(({ key, ...buttonProps }) => (
				<Button
					key={key}
					iconOnly={iconOnly}
					variant={variant}
					variantSize={variantSize}
					{...buttonProps}
					disabled={disabled || buttonProps.disabled}
				/>
			))}
		</div>
	);
};
